//get cycle

import type {
  CreateReminderDTOType,
  CreateReminderResponseType,
  GetCycleDTOType,
  GetCycleResponseType,
  GetCyclesDTOType,
  GetCyclesResponseType,
  UpdateReminderDTOType,
} from '@/features/admin/reminders/types'
import fetchClient from '@/lib/fetch'

export const REMINDER_QUERY_KEY = 'v1-cycle'
export const V1_CYCLES_QUERY_KEY = 'v1-cycles'
export async function getCycles({ page, perPage }: GetCyclesDTOType): Promise<GetCyclesResponseType> {
  return fetchClient(`/v1/cycle/all?&page=${page}&perPage=${perPage}`, {
    method: 'GET',
  })
}

export function createReminderMutation(data: CreateReminderDTOType): Promise<CreateReminderResponseType> {
  return fetchClient(`/v1/cycle`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export function updateReminderMutation(data: UpdateReminderDTOType): Promise<CreateReminderResponseType> {
  return fetchClient(`/v1/cycle/${data.id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

export function getReminder(data: GetCycleDTOType): Promise<GetCycleResponseType> {
  return fetchClient(`/v1/cycle/${data.id}`, {
    method: 'GET',
  })
}

export function deleteCycleMutation(cycleId: string): Promise<{ message: string }> {
  return fetchClient(`/v1/cycle/${cycleId}`, {
    method: 'DELETE',
  })
}
